// The Order Review's PACK/CASE label (Figma header 4977:1745) from the catalogue's own pack
// facts: the pack size and the unit of measure, joined with a middle dot exactly as the
// product card and the product page join them, so one product reads the same everywhere.
// SL1.0 renders `RetailUnits / CaseSize` in this column (`get_orders_cost.php:313`); the
// catalogue holds neither field, so the label is built from what it does hold.

/** The PACK/CASE label, or `null` when the catalogue holds no pack fact for the product. */
export function packCaseLabel(
  packSize: string | null,
  unitOfMeasure: string | null,
): string | null {
  const parts = [packSize, unitOfMeasure]
    .map((part) => part?.trim() ?? '')
    .filter((part) => part !== '');
  return parts.length === 0 ? null : parts.join(' · ');
}
